import { render } from "./PlanFeature.vue?vue&type=template&id=0d7f75d2&scoped=true"
import script from "./PlanFeature.vue?vue&type=script&lang=ts"
export * from "./PlanFeature.vue?vue&type=script&lang=ts"

import "./PlanFeature.vue?vue&type=style&index=0&id=0d7f75d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d7f75d2"

export default script